import Field from 'components/forms/Field'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import { parseError } from 'utils'
import * as Yup from 'yup'
import LoadingIcon from './LoadingIcon'

function LoginForm(props) {
  const initial = {
    username: '',
    password: '',
  }

  const LoginSchema = Yup.object().shape({
    username: Yup.string().required('Please enter your username'),
    password: Yup.string().required('Please enter your password'),
  })

  const submit = async (values, actions) => {
    console.log('submitting login form')
    try {
      await props.onSubmit(values)
    } catch (err) {
      const { field_errors } = parseError(err)
      actions.setErrors(field_errors)
    }
  }

  return (
    <Card className="shadow">
      <Card.Body>
        <Card.Title>LOGIN</Card.Title>
        <Formik
          initialValues={initial}
          onSubmit={submit}
          validationSchema={LoginSchema}
        >
          {({ isSubmitting }) => (
            <Form>
              <Field name="username" />
              <Field name="password" type="password" />
              <Row>
                <Col md={5} lg={4}>
                  <Button
                    variant="warning"
                    type="submit"
                    disabled={isSubmitting}
                    block
                  >
                    {isSubmitting ? <LoadingIcon size="xs" /> : 'LOG IN'}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  )
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default LoginForm
